import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const REPLACE_DISH_TYPE_MUTATION = gql`
  mutation replaceDishType($idToReplace: ID!, $replacementId: ID!) {
    replaceDishType(idToReplace: $idToReplace, replacementId: $replacementId) {
      results {
        ...DishTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REPLACE_DISH_TYPE_MUTATION
